const initialState = {
    searchText: "",
    currentPage: 1,
    perPage: "20",
    activated: [],
    deactivated: [],
    pending: [],
    filterStatus: 2,
  };
  /**
   * teporary save the state of passwords if user change his password
   * @param {object} state
   * @param {object} action
   */
  
  const tableFilterReducer = (state = initialState, action) => {
    switch (action.type) {
      case "'CHANGE_NAME'":
        return { ...state, name: action.payload };
  
      // case "SET_PAGE":
      //   return { ...state, page: action.page, title: action.title };
  
      case "CHANGE_FILTER_STATUS":
        return {
          ...state,
          activated: action.payload.activated,
          deactivated: action.payload.deactivated,
          pending: action.payload.pending,
        };
  
      case "SET_FILTER_STATUS":
        return { ...state, filterStatus: action.payload.status, currentPage: 1 };
  
      case "FILTER_LIST_RECORDS_BY_SEARCH_TEXT":
        return { ...state, searchText: action.payload.searchText };
  
      case "SET_PER_PAGE":
        return { ...state, perPage: action.payload.perPage, currentPage: 1 };
  
      case "SET_CURRENT_PAGE":
        return { ...state, currentPage: action.payload.currentPage };
  
      case "RESET_FILTERS":
        return { ...state, ...initialState };
  
      default:
        return state;
    }
  };
  
  export default tableFilterReducer;
  